// extracted by mini-css-extract-plugin
module.exports = {"pt-tabbar":"pt-tabbar-9f229c83714a10ec1114f6029e2f1247"};